import { useEffect, useRef } from 'react'
import { motion } from 'motion/react'
import { useChatStore } from '../../store/chatStore'
import { useAuthStore } from '../../store/authStore'
import MessageBubble from './MessageBubble'
import Avatar from '../ui/Avatar'
import Spinner from '../Spinner'

interface Props {
  loading: boolean
  onReply: (msg: any) => void
  onReact: (msgId: string, emoji: string) => void
}

export default function MessageList({ loading, onReply, onReact }: Props) {
  const { activeConversation, messages } = useChatStore()
  const { user } = useAuthStore()
  const bottomRef = useRef<HTMLDivElement>(null)
  const convo = activeConversation
  const roomId = convo?.id
  const name = convo?.title || 'Chat'
  const isGroup = convo?.type === 'group'
  const roomMessages = (roomId ? messages[roomId] : []) || []

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [roomMessages])

  return (
    <div className="messages-area">
      {loading && (
        <div className="flex-center p-20"><Spinner size={24} /></div>
      )}

      {!loading && roomMessages.length === 0 && (
        <div className="empty-chat">
          <Avatar name={name} size={72} className="empty-avatar" />
          <h3>{name}</h3>
          <p>{isGroup ? `${convo?.members?.length || 0} members` : 'Send a message'}</p>
        </div>
      )}

      {roomMessages.map((msg: any, i: number) => {
        const isMine = msg.sender_id === user?.uid
        const prev = roomMessages[i - 1]
        const showDate = i === 0 || new Date(msg.created_at).toDateString() !== new Date(prev?.created_at).toDateString()

        return (
          <MessageBubble
            key={msg.id}
            msg={msg}
            isMine={isMine}
            showDate={showDate}
            onReply={onReply}
            onReact={onReact}
          />
        )
      })}
      <div ref={bottomRef} />
    </div>
  )
}
